export default "__VITE_ASSET__Qjk2rOYZ__"